<template>
  <a class="navbar-brand" href="/" v-if="es">
    <img :src="require('@/assets/img/logo.png')"
         alt="Logo oficial de Flatprive — alquiler de pisos y habitaciones en León" width="auto" height="60">
  </a>
  <a class="navbar-brand" href="/en" v-if="!es">
    <img :src="require('@/assets/img/logo.png')" alt="Official logo Flatprive — rent apartments and rooms in León "
         width="auto" height="60">
  </a>
</template>

<script>
export default {
  name: 'AppLogo',
  computed: {
    es() {
      return this.$i18n.locale === 'es';
    }
  }
}
</script>